import React from "react";
import DropdownIcon from "../../../assets/images/DropDownIcon";
export const selectBoxStyle: React.CSSProperties = {
  appearance: "none", // Hide the default dropdown arrow provided by the browser
};
interface SelectProps {
  handleOnChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options: string[];
  placeholder?: string;
  name?: string;
  value?: string;
  label?: string;
  borderColor?: string;
}

const Dropdown = ({
  handleOnChange,
  options,
  placeholder,
  name,
  value,
  label,
  borderColor,
}: SelectProps) => {
  return (
    <div
      className={`relative mt-5 border ${
        borderColor || "border-sideMenuHelpBox"
      } 
      rounded-xl focus-within:border-blue-500`}
    >
      <label
        htmlFor={label}
        className={`absolute top-0 left-2 bg-white px-2 labelText ${
          borderColor === "border-redColor" && "text-redColor"
        }`}
      >
        {label}
      </label>
      <select
        id={label}
        name={name}
        onChange={handleOnChange}
        className={`w-full p-4 ${
          value && value?.toString().length !== 0
            ? "text-inputTextColor "
            : "text-sideMenuHelpBox"
        } placeHolderText border border-transparent rounded-2xl focus:outline-none  bg-white`}
        required
        value={value} // Use the value prop to control the selected value
        style={selectBoxStyle} // Apply the CSS class to increase the size of the dropdown arrow
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option, index) => (
          <option
            key={option}
            value={option}
            className="text-inputTextColor placeHolderText"
          >
            {option}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 top-2 flex items-center pr-3 pointer-events-none">
        <DropdownIcon />
      </div>
    </div>
  );
};

export default Dropdown;
